var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactMouseEvent } from "../events";
import { SurveyActionBar, ReactElementFactory, } from "survey-react-ui";
var QuestionWrapperFooter = /** @class */ (function (_super) {
    __extends(QuestionWrapperFooter, _super);
    function QuestionWrapperFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionWrapperFooter.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: this.props.className, onFocus: function (e) { return _this.props.model.select(_this.props.model, new ReactMouseEvent(e)); } },
            React.createElement(SurveyActionBar, { model: this.props.model.actionContainer, handleClick: false })));
    };
    return QuestionWrapperFooter;
}(React.Component));
export { QuestionWrapperFooter };
ReactElementFactory.Instance.registerElement("svc-question-footer", function (props) {
    return React.createElement(QuestionWrapperFooter, props);
});
